import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import proEn from './locales/en/pro.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        pro: proEn,
      },
    },
    lng: 'en',
    fallbackLng: 'en',
    defaultNS: 'pro',
    interpolation: {
      escapeValue: false, // React already escapes
    },
  });

export default i18n;
